<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="分类名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim();}"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="type"
                    label="内容类型"
                    prop="type"
                    :extra="formErr.type"
                    :validateStatus='!formErr.type||formErr.type==""?"":"error"'
            >
                <a-radio-group v-model="form.type"  >
                    <a-radio :value="item.value" v-for="(item, idx) in this.typeList" :key="idx"> {{item.name}} </a-radio>

                </a-radio-group>
            </a-form-model-item>
<!--            <a-form-model-item-->
<!--                    ref="release_time"-->
<!--                    label="发布时间"-->
<!--                    prop="release_time"-->
<!--                    :help="formErr.release_time"-->
<!--                    :validateStatus='!formErr.release_time||formErr.release_time==""?"":"error"'-->
<!--            >-->
<!--                <a-date-picker  :format="dateFormat" show-time  v-model="form.release_time"/>-->
<!--            </a-form-model-item>-->
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" v-for="(item, idx) in this.statusList" :key="idx"> {{item.name}} </a-radio>

                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"

    import API from "../api";
    import moment from 'moment';
    export default {
        name: "newForm",
        // props: ["visible","title","editId"],
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},
        },
        data() {
            return {
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                typeList:[],
                statusList:[],
                drawerConfig:drawerConfig,
                form: {
                    name:"",
                    // release_time:moment(new Date(), 'YYYY-MM-DD HH:mm:SS'),
                    type:1,
                    status:1,
                },
                formErr: {
                    name:"",
                    type:"",
                    release_time:"",
                    status:"",
                },
                rules: {
                    name: [{required: true, message: "请输入分类名称",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let data=res.data.data.info
                        this.form = data
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
            this.getFormData()
        },
        computed: {

        },
        methods: {

            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.statusList=res.data.data.status
                    this.typeList=res.data.data.type
                })
            },

            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                    name:"",
                    type:"",
                    status:"",
                }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
</style>
